import { TextField } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
    name: string;
    label: string;
    helperText?: string;
};

export default function RHFDatePicker({ name, label, helperText, ...other }: Props) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <DatePicker
                    {...field}
                    label={label}
                    value={field.value || null}
                    onChange={date => field.onChange(date)}
                    renderInput={params => (
                        <TextField
                            {...params}
                            helperText={error ? error.message : helperText}
                            error={!!error}
                            variant='outlined'
                            fullWidth
                            {...other}
                        />
                    )}
                />
            )}
        />
    );
}
